// IntroductionTable
const Styles = {
  tableRow: {
    "& > *": { borderBottom: "unset" },
    background: "#F2F2F2",
    border: "1px solid #DADADA",
    p: 1,
  },

  tableHeadCell: {
    p: 1,
    fontSize: 10,
    borderBottom: "none",
    color: "#0000ff",
    paddingBottom: 0,
  },

  tableBodyCell: {
    p: 1,
    fontSize: 10,
    borderBottom: "none",
    paddingTop: 0,
  },

  tableRowSecondary: {
    p: 1,
    fontSize: 10,
    borderBottom: "none",
    paddingTop: 0,
    display: "flex",
  },

  buttonStyle: {
    fontSize: 10,
    border: "1px solid crimson",
    borderRadius: "10px",
    color: "#616161",
    padding: "0 10px",
  },

  linkStyle: {
    textDecoration: "none",
    color: "#616161",
  },

  // viewIntroduction (jsx file)

  container: {
    height: "100%",
  },

  divLoader: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "12px",
  },

  typography: {
    fontSize: "28px",
    fontWeight: "400",
  },

  // View Transfer Style
  popUp: {
    position: "absolute",
    top: "45px",
    transform: "translate(-50%, -50%)",
    width: 900,
    maxHeight: 700,
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "12px 20px 16px 20px",
  },
  // introductionRadio.jsx

  typographyRadio: {
    fontSize: 12,
  },

  notFound: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    marginTop: 150,
  },
  left: {
    display: "flex",
    gap: "1rem",
  },
};

export const organizationStructureBlockStyles = {
  text: {
    fontSize: 10,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    paddingLeft: 4,
    paddingRight: 4,
  },
  brick: {
    width: 85,
    borderRadius: 2,
    border: "none",
    backgroundColor: "#F2F2F2",
    height: 21,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  area: {
    backgroundColor: "transparent",
    border: "1px solid #4327AE",
  },
  areaFilled: {
    backgroundColor: "#4327AE",
    color: "white",
  },
  zone: {
    border: "1px solid #0B15FA",
  },
  zoneFilled: {
    backgroundColor: "#0B15FA",
    color: "white",
  },
  region: {
    border: "1px solid #0BB2FA",
  },
  regionFilled: {
    backgroundColor: "#0BB2FA",
    color: "white",
  },
  chapter: {
    border: "1px solid #0BAB5E",
  },
  chapterFilled: {
    backgroundColor: "#0BAB5E",
    color: "white",
  },
  district: {
    border: "1px solid #F97D0A",
  },
  districtFilled: {
    backgroundColor: "#F97D0A",
    color: "white",
  },
};

export default Styles;
